/* Crampons Premium — thème v25 */
(function(){
'use strict';
const $=s=>document.querySelector(s), $$=s=>document.querySelectorAll(s);
const read=id=>{const el=document.getElementById(id);try{return el?JSON.parse(el.textContent):[]}catch(e){return[]}};
const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const vt=fn=>document.startViewTransition?document.startViewTransition(fn):fn();

const S=read('cp-boots');
const CLUBS=read('cp-clubs');
const CLUBS2=read('cp-clubs2').length?read('cp-clubs2'):CLUBS;
const LIGUES2=read('cp-ligues2');

/* ── RAYON VITRINE ── */
const shoe=(k,i)=>`<a class="bt stag${k.fl?' fl':''}" style="--i:${i}" href="${esc(k.u||'#')}">
 <div class="ph"><img loading="lazy" decoding="async" src="${esc(k.img)}" alt="${esc(k.b+' '+k.n)}"></div>
 <div class="meta"><div class="br">${esc(k.b)}</div><div class="nm">${esc(k.n)}</div>
 <div class="tl">${esc(k.t)}${k.s?' · '+esc(k.s):''}</div><div class="pz">${esc(k.p)}</div></div></a>`;
function drawRayon(list){
 const el=$('#rayon'); if(!el)return;
 const per=matchMedia('(max-width:640px)').matches?2:matchMedia('(max-width:1180px)').matches?3:5;
 let h='',i=0;
 for(let r=0;r<list.length;r+=per) h+='<div class="row">'+list.slice(r,r+per).map(k=>shoe(k,i++)).join('')+'</div>';
 el.innerHTML=h;
}
drawRayon(S);
let rz; addEventListener('resize',()=>{clearTimeout(rz);rz=setTimeout(()=>drawRayon(S),180)},{passive:true});

/* ── ÉCUSSONS ── */
const disc=x=>`<a class="cd" style="--c:${esc(x.c)}" href="${esc(x.u||'#')}">
 <span class="ring"><img loading="lazy" src="${esc(x.img)}" alt="${esc(x.n)}"></span><span>${esc(x.n)}</span></a>`;
const hg=$('#hgrid');
if(hg) hg.innerHTML=CLUBS.slice(0,8).map(x=>`<a href="${esc(x.u||'#')}"><img loading="lazy" src="${esc(x.img)}" alt="${esc(x.n)}"></a>`).join('')
 +`<a class="more" href="/collections"><b>+88</b><span>Voir tous</span></a>`;
const all=$('#allCrests');
if(all){
 all.innerHTML=CLUBS2.map(disc).join('');
 $$('#tog .ch').forEach(b=>b.addEventListener('click',()=>{
  $$('#tog .ch').forEach(x=>x.classList.remove('on')); b.classList.add('on');
  const list=b.dataset.v==='clubs'?CLUBS2:LIGUES2;
  vt(()=>all.innerHTML=list.map(disc).join(''));
 }));
}

/* ── CHIFFRES ANIMÉS ── */
$$('[data-c]').forEach(el=>{
 const end=parseInt(el.dataset.c,10)||0;
 const io=new IntersectionObserver(es=>es.forEach(e=>{
  if(!e.isIntersecting)return; io.disconnect();
  const t0=performance.now(),d=1100;
  (function step(t){const p=Math.min(1,(t-t0)/d);el.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(step)})(t0);
 }),{threshold:.4});
 io.observe(el);
});

/* ── COMPTE À REBOURS 15 H ── */
const cH=$('#cH'),cM=$('#cM'),cS=$('#cS');
if(cH){const pad=n=>String(n).padStart(2,'0');
 (function tk(){const now=new Date(),d=new Date(now);d.setHours(15,0,0,0);if(d<=now)d.setDate(d.getDate()+1);
  const s=Math.floor((d-now)/1000);
  cH.textContent=pad(Math.floor(s/3600));cM.textContent=pad(Math.floor(s%3600/60));cS.textContent=pad(s%60);
  setTimeout(tk,1000);})();}

/* ── HEADER COLLANT ── */
const hd=$('#hd');
if(hd) addEventListener('scroll',()=>hd.classList.toggle('stuck',scrollY>10),{passive:true});
})();
